module.exports = __webpack_public_path__ + "img/一星高级大师@2x.1c62705f.png";